<template>
<inertia-head title="Bo Sanchez - TRC Upcoming Events" />
<div class="bg-trc-main">
	<div class="bg-black-25">
		<div class="content text-center">
			<div class="py-0 mb-3">
				<h1 class="fw-bold text-white mb-2">
				TRC UPCOMING EVENTS
				</h1>
				<h3 class="text-white">
				
				Don't miss out on these electrifying Truly Rich Club events that promise to ignite your financial, personal, and career growth. Get ready to take charge of your destiny and step into a brighter, more prosperous future!
				</h3>
			</div>
		</div>
	</div>
</div>
<div v-if="featuresEvents.length>0" class="border-bottom border-4 border-primary shadow mb-5">
	<div class="featured-videos-bg p-4">
		<div class="row">
			<h1 class="text-white fw-bold">FEATURED EVENTS</h1>
			<div v-for="event in featuresEvents" :class="{'col-sm-12 col-md-12 col-lg-12':featuresEvents.length==1,'col-sm-6 col-md-6 col-lg-6':featuresEvents.length==2}">
				<div class="block border shadow">
					<img :src="event.event_image_url" style="width:100%">
					<div class="block-content pb-4 pt-1">
						<div>
							<p class="m-0">{{event.date_display}} @ {{event.time_display}}</p>
							<h4 style="min-height: 50px;">{{event.title}}</h4>
							<p>Location: {{event.location}}</p>
						</div>
						<div class="text-center">
							<a v-if="event.info_link!=null" :href="event.info_link" class="btn btn-warning rounded-pill py-2 px-4 me-2" target="_blank">More Info</a>
							<button v-if="event.event_link==null" @click="notifyMe(event)" type="button" class="btn btn-info btn-hero rounded-pill py-2 px-4">Notify Me</button>
							<a v-else :href="event.event_link" class="btn btn-success rounded-pill py-2 px-4" target="_blank">Get Tickets</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="content">
	<div class="my-4">
		<div class="input-group">
			<input v-model="formSearch.search" type="text" name="search" class="form-control" placeholder="Search location...">
			<span class="input-group-btn">
				<button @click="searchEvents" type="button" class="btn btn-info">Search</button>
			</span>
		</div>
	</div>
	<div v-for="(event,key) in events" class="row mb-5">
		<h1>{{key}}</h1>
		<div v-for="evt in event" :class="{'col-sm-12 col-md-12 col-lg-12':event.length==1,'col-sm-6 col-md-6 col-lg-6':event.length==2,'col-sm-4 col-md-4 col-lg-4':event.length>=4}">
			<div class="block border shadow">
				<img :src="evt.event_image_url" style="width:100%">
				<div class="block-content pb-4 pt-1">
					<div>
						<p class="m-0">{{evt.date_display}} @ {{evt.time_display}}</p>
						<h4 style="min-height: 50px;">{{evt.title}}</h4>
						<p>Venue: {{evt.location}}</p>
					</div>
					<div class="text-center">
						<a v-if="evt.info_link!=null" :href="evt.info_link" class="btn btn-warning rounded-pill py-2 px-4 me-2" target="_blank">More Info</a>
						<button v-if="evt.event_link==null" @click="notifyMe(evt)" type="button" class="btn btn-info btn-hero rounded-pill py-2 px-4">Notify Me</button>
						<a v-else :href="evt.event_link" class="btn btn-success rounded-pill py-2 px-4" target="_blank">Get Tickets</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-if="events.length<=0" class="row mb-5">
		<div class="col-sm-12 col-md-12 col-lg-12 text-center">
			<h2 class="text-danger">No Upcoming Events Found</h2>
		</div>
	</div>
</div>
<!-- Footer -->
<footer id="page-footer">
	<div class="content py-3">
		<div class="row fs-sm">
			<div class="col-sm-12 order-sm-1 py-1 text-center">
				<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
				&copy; {{ $page.props.app.year }}
			</div>
		</div>
	</div>
</footer>
<modal ref="notifyMeModal" size="modal-md">
<template #title>
Notify Me
</template>
<template #body>
<div class="text-center">
	<h1>{{form.title}}</h1>
	<h3 class="text-gray-dark">Tell me when tickets becomes availabe!</h3>
	<h5 class="text-gray-dark">Get updates and exclusive rate when tickets go live!</h5>
</div>
<div class="form-group mb-3">
	<label>First Name</label>
	<input type="text" v-model="form.fname" name="fname" class="form-control"/>
	<span v-if="form.errors.fname" class="text-danger">{{form.errors.fname}}</span>
</div>
<div class="form-group mb-3">
	<label>Last Name</label>
	<input type="text" v-model="form.lname" name="lname" class="form-control"/>
	<span v-if="form.errors.lname" class="text-danger">{{form.errors.lname}}</span>
</div>
<div class="form-group mb-3">
	<label>Email</label>
	<input type="text" v-model="form.email" name="email" class="form-control"/>
	<span v-if="form.errors.email" class="text-danger">{{form.errors.email}}</span>
</div>
<div class="form-group mb-3">
	<label>Mobile</label>
	<vue-tel-input
	@input="onInput"
	@countryChanged="onCountryChange"
	v-model="form.mobile"
	:value="form.mobile"
	class="form-control"
	:class="{ 'is-invalid': form.errors.mobile }"
	:input-options="{
	placeholder: 'Enter mobile number',
	}"
	:defaultCountry="form.country_code"
	mode="international"
	/>
	<span v-if="form.errors.mobile" class="text-danger">{{form.errors.mobile}}</span>
</div>
</template>
<template #footer>
<button @click="notifyMeEvent" type="button" class="btn btn-sm btn-success"><i class="fa fa-exclamation-circle"></i> Notify Me</button>
<button type="button" class="btn btn-sm btn-secondary" @click="notifyMeModal.toggleModal()"><i class="fa fa-times"></i> Cancel</button>
</template>
</modal>
</template>
<script>
	import GuestLayout from '../Layouts/FreeBookLayout';
	import { watch, ref, onMounted } from 'vue'
	import { useForm } from '@inertiajs/inertia-vue3'
	import { Inertia } from '@inertiajs/inertia';
	export default{
		layout: GuestLayout,
		props:{
				featuresEvents 	: Object,
						events 			: Object,
						flash 			: Object,
						search			: String,
		},
		setup(props){
			const notifyMeModal = ref(null);
			const formSearch = useForm({
				search : props.search
			});
			const form = useForm({
					upcoming_event_uuid: null,
							title 		: '',
							fname 		: '',
							lname 		: '',
							email 		: '',
					country_calling_code: '63',
					country_code: '',
							mobile		: ''
				})
			const onInput = (number, phoneObject) => {
				if (phoneObject?.formatted) {
									form.mobile 				= phoneObject.number;
						form.country_calling_code 	= phoneObject.countryCallingCode;
				}
				if(phoneObject.formatted=='')
				{
					form.mobile = '';
				}
			}
			const onCountryChange = (countryObject) => {
				form.country_code = countryObject.iso2
			}
			const notifyMe = (_event)=>{
				form.upcoming_event_uuid = _event.upcoming_event_uuid;
				form.title = _event.title;
				notifyMeModal.value.toggleModal();
			}
			const searchEvents = ()=>{
				formSearch.get(route("upcoming-events",{search:formSearch.search}),
				{
					preserveState: true,
					preserveScroll: true,
					only:['flash,errors,featuresEvents,events,search']
				})
			}
			const notifyMeEvent = ()=>{
				form.post(route("upcoming-events-notifyme"),{
					only:['flash,errors,featuresEvents,events,search'],
					onSuccess:()=>{
						form.reset();
						notifyMeModal.value.toggleModal();
					}
				});
			}
			watch(
				() => props.flash,
				(flash) => {
					if (flash && flash.toast) {
						if(flash.toast.type=='success')
						{
							Inertia.get("events/thankyou/"+flash.toast.data);
						}
						
					}
				}
			)
			return {
				formSearch,
				form,
				notifyMeModal,
				onInput,
				onCountryChange,
				notifyMe,
				searchEvents,
				notifyMeEvent,
			}
		}
	}
</script>